// Electric Wheels Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Menu Toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      this.classList.toggle('active');
    });
  }

  // Product Filter Pills - DISABLED FOR NOW (filtering not implemented yet)
  // const filterPills = document.querySelectorAll('.filter-pill');
  // filterPills.forEach(pill => {
  //   pill.addEventListener('click', function() {
  //     filterPills.forEach(p => p.classList.remove('active'));
  //     this.classList.add('active');
  //   });
  // });

  // Sticky Header on Scroll
  const header = document.getElementById('site-header');
  let lastScroll = 0;

  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset;

    if (currentScroll > 100) {
      header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.3)';
    } else {
      header.style.boxShadow = 'none';
    }

    lastScroll = currentScroll;
  });

  // Scroll Reveal Animation
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animation = 'fadeInUp 0.6s ease forwards';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe product cards and sections
  document.querySelectorAll('.product-card, .feature-card, .testimonial-card').forEach(el => {
    el.style.opacity = '0';
    observer.observe(el);
  });

  // Quick Add to Cart
  const quickAddButtons = document.querySelectorAll('.product-card-quick-add');
  quickAddButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const productId = this.dataset.productId;
      const originalText = this.innerHTML;

      // Add visual feedback
      this.innerHTML = '<span class="quick-add-icon">✓</span><span class="quick-add-text">ADDED!</span>';
      this.style.background = '#00A86B';

      // Simulate add to cart (implement actual cart logic)
      setTimeout(() => {
        this.innerHTML = originalText;
        this.style.background = '';

        // Update cart count
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          const currentCount = parseInt(cartCount.textContent) || 0;
          cartCount.textContent = currentCount + 1;
        }
      }, 1500);
    });
  });

  // Newsletter Form Handling
  const newsletterForms = document.querySelectorAll('.newsletter-form, .newsletter-signup-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const button = this.querySelector('button[type="submit"]');
      if (button) {
        const originalText = button.textContent;
        button.textContent = 'SUBSCRIBING...';
        button.disabled = true;

        // Re-enable after submission
        setTimeout(() => {
          button.textContent = 'SUBSCRIBED!';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        }, 1000);
      }
    });
  });

  // Product Image Gallery
  const productThumbs = document.querySelectorAll('.product-thumb');
  productThumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const mainImage = document.getElementById('main-product-image');
      if (mainImage) {
        mainImage.src = this.dataset.image;
        productThumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  // Color Swatch Interaction
  const colorSwatches = document.querySelectorAll('.color-swatch');
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const parent = this.closest('.product-card');
      if (parent) {
        parent.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('selected'));
        this.classList.add('selected');
      }
    });
  });

  // Smooth Scroll for Anchor Links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '#MainContent') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Add to Cart Button State
  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function() {
      if (!this.disabled) {
        const originalText = this.textContent;
        this.textContent = 'ADDING...';

        setTimeout(() => {
          this.textContent = 'ADDED TO CART!';
          setTimeout(() => {
            this.textContent = originalText;
          }, 2000);
        }, 500);
      }
    });
  });
});

// Utility Functions
function incrementQuantity() {
  const input = document.getElementById('quantity');
  if (input && parseInt(input.value) < parseInt(input.max)) {
    input.value = parseInt(input.value) + 1;
  }
}

function decrementQuantity() {
  const input = document.getElementById('quantity');
  if (input && parseInt(input.value) > parseInt(input.min)) {
    input.value = parseInt(input.value) - 1;
  }
}

function changeMainImage(thumb) {
  const mainImage = document.getElementById('main-product-image');
  if (mainImage && thumb.dataset.image) {
    mainImage.src = thumb.dataset.image;
    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  }
}
